// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const PushNotification = () => {
//   const [title, setTitle] = useState("");
//   const [body, setBody] = useState("");
//   const [users, setUsers] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);

//   // ✅ Fetch Users with FCM Tokens
//   useEffect(() => {
//     const fetchUsersId = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/user-contacts`
//         );
//         // const usersIdList = response.data.map((user) => user.id);
//         setUsers(response.data);
//       } catch (error) {
//         console.error("Error fetching user's id:", error);
//       }
//     };

//     fetchUsersId();

//     // axios
//     //   .get(`${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/user-contacts`)
//     //   .then((res) => {
//     //     setUsers(res.data);
//     //   });
//   }, []);
//   console.log("List user data", users);
//   // ✅ Send Notification
//   // const sendNotification = async () => {
//   //   try {
//   //     const tokens = users
//   //       .filter((user) => selectedUsers.includes(user.id))
//   //       .map((user) => user.fcmToken)[0];

//   //     await axios.post(
//   //       `${
//   //         process.env.REACT_APP_API_DOMAIN ?? ""
//   //       }/api/auth/notifications/send-push`,
//   //       {
//   //         title,
//   //         body,
//   //         tokens,
//   //       }
//   //     );

//   //     alert("✅ Notification sent!");
//   //   } catch (error) {
//   //     console.error("❌ Error sending notification:", error);
//   //   }
//   // };
//   // const sendNotification = async () => {
//   //   if (selectedUsers.length === 0) {
//   //     alert("Please select at least one user.");
//   //     return;
//   //   }

//   //   try {
//   //     await axios.post(
//   //       `${
//   //         process.env.REACT_APP_API_DOMAIN ?? ""
//   //       }/api/auth/notifications/send-push`,
//   //       {
//   //         selectedUsers: selectedUsers[0], // Send array of user IDs
//   //         title,
//   //         body,
//   //       }
//   //     );

//   //     alert("✅ Notification sent!");
//   //   } catch (error) {
//   //     console.error("❌ Error sending notification:", error);
//   //   }
//   // };

//   const sendNotification = async () => {
//     try {
//       const tokens = users
//         .filter((user) => selectedUsers.includes(user.id))
//         .map((user) => user.fcmToken); // ✅ Get all tokens

//       if (tokens.length === 0) {
//         alert("No users selected or no valid FCM tokens.");
//         return;
//       }

//       await axios.post(
//         `${
//           process.env.REACT_APP_API_DOMAIN ?? ""
//         }/api/auth/notifications/send-push`,
//         {
//           title,
//           body,
//           userIds: selectedUsers, // ✅ Send selected user IDs to backend
//         }
//       );

//       alert("✅ Notification sent!");
//     } catch (error) {
//       console.error("❌ Error sending notification:", error);
//     }
//   };

//   return (
//     <form>
//       <div className="mb-1 mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Title"
//           value={title}
//           onChange={(e) => setTitle(e.target.value)}
//         />
//       </div>
//       <div className="mb-1 mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Message"
//           value={body}
//           onChange={(e) => setBody(e.target.value)}
//         />
//         <div className="mb-2">
//           <h4>Select Users:</h4>
//           <div className="mb-2">
//             {users.map((user) => (
//               <div key={user.id}>
//                 <input
//                   type="checkbox"
//                   checked={selectedUsers.includes(user.id)}
//                   onChange={() =>
//                     setSelectedUsers((prev) =>
//                       prev.includes(user.id)
//                         ? prev.filter((id) => id !== user.id)
//                         : [...prev, user.id]
//                     )
//                   }
//                 />
//                 {user.email}
//               </div>
//             ))}
//           </div>
//         </div>
//         <button onClick={sendNotification}>Send Notification</button>
//       </div>
//     </form>
//   );
// };

// export default PushNotification;
import React, { useState, useEffect } from "react";
import axios from "axios";

const PushNotification = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectAll, setSelectAll] = useState(false); // ✅ Track "Select All"

  // ✅ Fetch Users with FCM Tokens
  useEffect(() => {
    const fetchUsersId = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/user-contacts`
        );
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching user's id:", error);
      }
    };

    fetchUsersId();
  }, []);

  console.log("List user data", users);

  // ✅ Toggle "Select All"
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedUsers([]); // Deselect all users
    } else {
      setSelectedUsers(users.map((user) => user.id)); // Select all users
    }
    setSelectAll(!selectAll);
  };

  // ✅ Send Notification
  const sendNotification = async () => {
    try {
      if (selectedUsers.length === 0) {
        alert("No users selected.");
        return;
      }

      await axios.post(
        `${
          process.env.REACT_APP_API_DOMAIN ?? ""
        }/api/auth/notifications/send-push`,
        {
          title,
          body,
          userIds: selectedUsers, // ✅ Send selected user IDs to backend
        }
      );

      alert("✅ Notification sent!");
    } catch (error) {
      console.error("❌ Error sending notification:", error);
    }
  };

  return (
    <form>
      <div className="mb-1 mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div className="mb-1 mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Message"
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />
      </div>

      {/* ✅ "Select All" Checkbox */}
      <div className="mb-2">
        <h6>Select Users:</h6>
        <div className="selall d-flex align-items-center">
          <input
            className="me-2"
            type="checkbox"
            checked={selectAll}
            onChange={handleSelectAll}
          />
          Select All
        </div>
      </div>

      {/* ✅ Individual User Selection */}
      <div className="row mb-2 mixxd border">
        {users.map((user) => (
          <div key={user.id} className="col-6 d-flex align-items-center">
            <input
              type="checkbox"
              className="me-2"
              checked={selectedUsers.includes(user.id)}
              onChange={() =>
                setSelectedUsers((prev) =>
                  prev.includes(user.id)
                    ? prev.filter((id) => id !== user.id)
                    : [...prev, user.id]
                )
              }
            />
            {user.email}
          </div>
        ))}
      </div>

      <button
        className="btn btn-secondary"
        type="button"
        onClick={sendNotification}
      >
        Send Notification
      </button>
    </form>
  );
};

export default PushNotification;
